import React from "react";
import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./userContext";

export const PrivateRoute = ({ children }) => {
  const { currentUser, isAuthenticated } = useUser();

  // Allow access only if authenticated and role is either admin or volunteer or employee
  return isAuthenticated &&
    (currentUser?.role === "admin" ||
      currentUser?.role === "employee" ||
      currentUser?.role === "volunteer") ? (
    children
  ) : (
    <div
      style={{
        width: "100%",
        height: "60vh",
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
        padding: "0 1rem 0 10% ",
        fontSize: "2rem",
        boxSizing: "border-box",
      }}
    >
      You have no permissions to access this page.
    </div>
  );
};

export const PrivateRouteAdmin = ({ children }) => {
  const { currentUser, isAuthenticated } = useUser();

  if (!isAuthenticated || !currentUser || currentUser?.role !== "admin") {
    return (
      <div
        style={{
          width: "100%",
          height: "60vh",
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          padding: "0 1rem 0 10% ",
          fontSize: "2rem",
          boxSizing: "border-box",
        }}
      >
        You have no permissions to access this page.
      </div>
    );
  }
  return children;
};
